import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ReportsServiceProvider } from '../../api/reports'

const ReportsService = ReportsServiceProvider()
const name = 'getReport'

export default (id) => (asyncAction(
  name,
  ReportsService.getReport,
  { id }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/reports/getReport.js